import * as React from "react";
import { UserX, Lock, FileWarning, ShieldAlert } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const problems = [{
  title: "Google Analytics",
  description: "Used for website traffic analysis and user behavior tracking to improve our digital experience.",
  icon: UserX,
  url: "https://policies.google.com/privacy"
}, {
  title: "Stripe",
  description: "Secure payment processing and financial infrastructure for all customer transactions.",
  icon: Lock,
  url: "https://stripe.com/privacy"
}, {
  title: "AWS",
  description: "Cloud infrastructure and data storage services ensuring high availability and security.",
  icon: FileWarning,
  url: "https://aws.amazon.com/privacy/"
}, {
  title: "Mailchimp",
  description: "Email marketing and newsletter distribution platform for customer communications.",
  icon: ShieldAlert,
  url: "https://mailchimp.com/legal/privacy/"
}];
export default function Thirdpartyservicestable() {
  return <section data-section-id="261063" id="thirdpartyservicestable" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-sm font-bold tracking-widest text-secondary uppercase mb-2 block font-default">
            TRANSPARENCY
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default mb-4">
            Third-Party Services & Privacy
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            We believe in full disclosure. Below are the essential third-party partners we use to provide our services securely and efficiently.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {problems.map((problem, i) => {
          const Icon = problem.icon;
          return <Card key={i} data-index={i} className="bg-card border-0 border-t-[3px] border-t-secondary shadow-lg rounded-lg overflow-hidden">
                <CardHeader className="pb-4 flex flex-row items-start gap-4 space-y-0">
                  <div className="bg-secondary/10 p-3 rounded-md shrink-0">
                    <Icon className="w-6 h-6 text-secondary" aria-hidden="true" />
                  </div>
                  <div>
                    <CardTitle className="text-xl font-bold text-foreground font-default mb-2">
                      {problem.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground font-default leading-relaxed mb-4">
                    {problem.description}
                  </p>
                  <a href={problem.url} target="_blank" rel="noopener noreferrer" className="text-secondary hover:underline font-default font-semibold text-sm inline-flex items-center">
                    View Privacy Policy
                  </a>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}